<!-- 客服 -->
<template>
  <!-- 客服 -->
  <button
    type="button"
    class="general-agent-service-trigger"
    :class="{ 'is-open': opened }"
    :title="$t('common.agentService')"
    :aria-label="$t('common.agentService')"
    :aria-expanded="opened ? 'true' : 'false'"
    aria-haspopup="dialog"
    @click.stop="open"
  >
    <!-- 沿用原侧栏的耳麦造型，重绘成与语言地球图标一致的线性SVG。 -->
    <ChatNavigationIcon name="support" />
  </button>
</template>

<script>
import ChatNavigationIcon from '@/components/chat-workbench/ChatNavigationIcon.vue';
/** 只打开App常驻总客服；不新建聊天实例、订单场景或导航历史。 */
export default {
  name: "GeneralAgentServiceTrigger",
  components: { ChatNavigationIcon },
  computed: {
    opened() {
      return this.$store.state.agentServiceUi.generalOpen && !this.$store.state.agentServiceUi.generalDocked;
    },
  },
  methods: {
    open() {
      this.$store.commit("agentServiceUi/openGeneral");
    },
  },
};
</script>

<style scoped lang="less">
.general-agent-service-trigger {
  display: inline-flex;
  flex: 0 0 auto;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
  color: #334155;
  font: inherit;
  cursor: pointer;
  transition: color 200ms ease, background-color 200ms ease;

  svg {
    width: 22px;
    height: 22px;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  &:hover { background: #f8fafc; }
  &.is-open { color: #246de0; background: #f2f7ff; }
  &:focus-visible { outline: 2px solid #4286f5; outline-offset: 2px; }

  @media (prefers-reduced-motion: reduce) { transition: none; }
}
</style>
